module.exports = __webpack_public_path__ + "lendingcircles/resource/App/static/img/resource-finder.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource-finder.png
// module id = hMR9
// module chunks = 1